import { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";

import { listCampaigns, deleteCampaign } from "../../../services/campaigns.api";
import { listWabaTemplates } from "../../../services/wabaTemplates.api";
import toastError from "../../../errors/toastError";

// Datos de la página "Campañas Meta" (0372 MC1). Reutiliza el motor de campañas (H10):
// una campaña Meta = Campaign con templateId. Filtra por templateId != null.
export function useMetaCampaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");

  const fetchCampaigns = useCallback(async (search = "") => {
    setLoading(true);
    try {
      const { data } = await listCampaigns({ searchParam: search || undefined, pageNumber: 1 });
      const records = Array.isArray(data?.records) ? data.records : [];
      setCampaigns(records.filter((c) => c.templateId));
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTemplates = useCallback(async () => {
    try {
      const { data } = await listWabaTemplates({});
      setTemplates(Array.isArray(data) ? data : []);
    } catch {
      // silencioso: la tabla muestra el id si no resuelve el nombre
    }
  }, []);

  useEffect(() => {
    fetchCampaigns();
    fetchTemplates();
  }, [fetchCampaigns, fetchTemplates]);

  const templateNameById = useMemo(() => {
    const map = {};
    templates.forEach((t) => {
      map[t.id] = t.name;
    });
    return map;
  }, [templates]);

  const handleSearch = (value) => {
    setSearchParam(value);
    fetchCampaigns(value);
  };

  const handleDelete = async (id) => {
    try {
      await deleteCampaign(id);
      toast.success("Campaña eliminada.");
      fetchCampaigns(searchParam);
    } catch (err) {
      toastError(err);
    }
  };

  return {
    campaigns,
    templateNameById,
    loading,
    searchParam,
    fetchCampaigns,
    handleSearch,
    handleDelete,
  };
}
